/**
 * Created by rak on 1/15/2016.
 */
'use strict';

angular.module('trackReporting')
  .controller('RepoPerformanceCtrl', function ($scope, widgetSettingsCreatorService, commonTrackService, $timeout, reportService, $stateParams, $filter, $translate, $uibModal, errorHandlingService, $rootScope) {
    //var device = {};
    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
    var startDate = '';
    var endDate = '';
    var mainUrlDetails = '&page=report.show';
    var column = [];
    var reportOptions = [];
    var _selectedReportOption = '';
    var _selectedReportOptionModel = '';
    var exportPath = '';
    var dateRangePickerSettings = {};
    $scope.moduleName = 'performancereport';
    var isGridCreated = false;
    var radioCache = commonTrackService.getDataFromLocalStorage('performanceRadioName');
    $scope.radio = {
      name: $stateParams.reportName ? $stateParams.reportName : (radioCache ? radioCache : 'EventSpeedOption')
    };
    var lastlocationWidgetData = commonTrackService.getsetLastLocatioWidgetData();
    $scope.isDataAvailable = true;
    $scope.isDriverWorkingHours = true;
    $scope.reportComboOption = {
      eventSpeedOption: null,
      driverExpiringLicense: null,
      driverWorkingHours: null,
      hasDefaultReportOption: {
        eventSpeedOption: true,
        driverExpiringLicense: true,
        driverWorkingHours: false
      }
    };
    var multiSelectReportOptionNames = {
      driverWorkingHours: {
        driverID: []
      }
    };
    $scope.reportHistory = '';

    $scope.diableRepoTab = {
      report: true
    };

    $scope.showRepoTab = 0;
    $scope.reportDetail = {};
    var source =
      {
        datatype: 'array',
        datafields: [],
        localdata: []
      };
    $scope.date = {
      startDate: $stateParams.dateFrom ? new Date($stateParams.dateFrom.replaceAll('-', '/').replace('T', ' ')) : new Date(commonTrackService.formatReportDateTime($filter('date')(new Date(), 'dd/MM/yyyy'), '00:00:00')),
      endDate: $stateParams.dateFrom ? new Date($stateParams.dateTo.replaceAll('-', '/').replace('T', ' ')) : new Date()
    };
    $scope.performanceReportPropList = [];
    var dateRangeCustomEventHandler = {
      eventHandlers: {
        'apply.daterangepicker': function () {
          startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
          endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');

          if ($scope.showRepoTab === 1) {
            $scope.getReport({
              _reportName: $scope.radio.name,
              _hasMap: $scope.hasMap,
              _comboModelName: _selectedReportOptionModel
            });
          }
          /* $timeout(function () {
           $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails + '&group=' + device.value + '&date_fr=' + startDate + '&date_to=' + endDate);
           }, 0);*/
        }
      }
    };

    commonTrackService.getDatePickerDetails().then(function (settings) {
      $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings,$scope.radio.name));
      dateRangePickerSettings = settings;
    });

    var loadFleetServerDetails = function () {
      return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
        $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
        $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails);
      });
    };

    $scope.repoVehicleSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'deviceID',
      disabled: radioCache === 'DriverWorkingHours'
    });

    var loadReportSettings = function () {
      return reportService.getReportSettings($scope.moduleName).then(function (performaceReportSettings) {
        $scope.performanceReportPropList = performaceReportSettings.reportList;
        reportOptions = performaceReportSettings.reportOptionList;
        exportPath = performaceReportSettings.exportPath;
      });
    };
    var loaddevice = function () {
      return commonTrackService.getDeviceComboList(false).then(function (vehicleList) {
        $scope.repoVehicleSettings.source = vehicleList;
        var cacheData = commonTrackService.getDataFromLocalStorage('performanceReport');
        if ($stateParams.vehicleId) {
          $scope.repoVehicle = $stateParams.vehicleId;
        } else if (lastlocationWidgetData.selectedRow && lastlocationWidgetData.selectedRow.deviceid) {
          $scope.repoVehicle = lastlocationWidgetData.selectedRow.deviceid;
        } else if (cacheData) {
          $scope.repoVehicle = cacheData;
        } else {
          $scope.repoVehicle = $scope.repoVehicleSettings.source[0].deviceID;
        }
      });
    };
    var loadReportOptions = function (name) {
      reportService.getCustomPerformanceRepotOptionComboData(name).then(function (reportOptionData) {
        if (name !== 'driverWorkingHours') {
          for (var i = 0; i < reportOptionData.length; i++) {
            reportOptionData[i].displayName = $translate.instant('trackReporting.performanceReport.reportComboboxOptions.' + name + '.' + reportOptionData[i].key);
          }
        }
        $scope[name + 'Settings'].source = reportOptionData;
        if ($scope.reportComboOption.hasDefaultReportOption[name]) {
          $scope.reportComboOption[name] = reportOptionData[0].key;
        }
        if (name === 'driverWorkingHours') {
          $scope[name + 'Settings'].source =  _.sortBy(reportOptionData, function (optopnobj) { return optopnobj.description.toLowerCase(); });
          if ($scope[name + 'Settings'].source [0].key !== 'selectAll') {
            $scope[name + 'Settings'].source.unshift({
              displayName: $translate.instant('additionalTranslation.comboboxOptionALL'),
              key: 'selectAll'
            });
          }
        }
      });
    };

    loadFleetServerDetails().then(function () {
      return loadReportSettings();
    }).then(function () {
      return loaddevice();
    }).finally(function () {

      for (var i = 0; i < reportOptions.length; i++) {
        /* create repot option combobox based on the option name specified under the reportSettings 'performanceReportSettings'
         * (e.g) 'driverWorkingHours' -> driverWorkingHoursSettings
         * refer reportService.getReportSettings()  for model, id other details of combobox.
         */
        $scope[reportOptions[i] + 'Settings'] = widgetSettingsCreatorService.createComboxSettings({
          displayMember: 'displayName',
          valueMember: 'key'
        });
        if (reportOptions[i] === 'driverWorkingHours') {
          $scope[reportOptions[i] + 'Settings'].checkboxes = true;
          $scope[reportOptions[i] + 'Settings'].autoComplete = false;
          $scope[reportOptions[i] + 'Settings'].dropDownHeight='300px';
        }
        for (var j = 0; j < $scope.performanceReportPropList.length; j++) {
          if ($scope.performanceReportPropList[j]._comboModelName === reportOptions[i]) {
            $scope[reportOptions[i] + 'Settings'].multiSelect = $scope.performanceReportPropList[j]._isReportOptionMultiSelect;
            break;
          }

        }

        loadReportOptions(reportOptions[i]);
      }

      initExport();

      $scope.dataLoadingFinished = true;
      $('#perforManceRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());
      $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').on('bindingcomplete', function () {
        isGridCreated = true;
        $timeout(function () {
          $('#perforManceRepoSpliter').jqxSplitter('render');
        }, 100);
      });
      $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').on('rowselect', function (event) {
        if (event.args && event.args.row && event.args.row.timestamp) {
          commonTrackService.iframePostMessage('jsmShowDetailPushpinForRoute_Dsa(' + event.args.row.timestamp + ')', 'groupMap');
        }
      });
      $scope.initSelectionFinished = true;
      $scope.isCreateCombobox = true;
      $timeout(function () {
        $('#driverWorkingHoursComboBox').on('checkChange', driverWorkingHoursCheckBoxChangeEvent);
      }, 100);

    });

    $scope.getReport = function (reportItem, event) {
      $scope.mapUrl = '';
      var reportName = reportItem._reportName, hasMap = reportItem._hasMap, reportOption = reportItem._comboModelName,
        multiSelectedComboboxOption;
      var gridState = reportService.getReportGridState('performanceReport', reportName);
      _selectedReportOptionModel = reportOption;
      $scope.error = false;
      $scope.exportOption = 'HTML';
      $scope.diableRepoTab.report = false;
      $scope.hasMap = hasMap;
      $scope.dataLoadingFinished = false;
      if (reportItem._isReportOptionMultiSelect) {
        multiSelectedComboboxOption = $('#' + reportItem._comboID).jqxComboBox('getSelectedItems');
      }


      var multiReportOption;

      if (multiSelectedComboboxOption && multiSelectedComboboxOption.length > 0) {
        multiSelectReportOptionNames[reportItem._comboModelName][reportItem._multiSelectPropertyName] = [];
        for (var i = 0; i < multiSelectedComboboxOption.length; i++) {
          multiSelectReportOptionNames[reportItem._comboModelName][reportItem._multiSelectPropertyName].push(multiSelectedComboboxOption[i].value);
        }
        multiReportOption = multiSelectReportOptionNames[reportItem._comboModelName];
        _selectedReportOption = null;

      } else {
        _selectedReportOption = _selectedReportOption ? _selectedReportOption : '';
      }

      startDate = startDate && !startDate._isAMomentObject ? startDate : $filter('date')($scope.date.startDate._isAMomentObject ? $scope.date.startDate._d : $scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
      endDate = endDate && !endDate._isAMomentObject ? endDate : $filter('date')($scope.date.endDate._isAMomentObject ? $scope.date.endDate._d : $scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');
      _selectedReportOption = $scope.reportComboOption[reportOption] && reportOption ? $scope.reportComboOption[reportOption] : '';
      $timeout(function () {
        if ($scope.hasMap) {
          $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, reportName, 'Device', event ? event.args.item.value : $scope.repoVehicle, _selectedReportOption, startDate, endDate);
        }
      }, 0);
      if (reportName === 'DriverWorkingHours') {
        multiReportOption = {
          driverID: _getDriverIds(hasAllOptionInSelectedList())
        };
      }
      var _tmpReportData = null;

      reportService.getVehilceReport($scope.moduleName, event ? event.args.item.value : $scope.repoVehicle, endDate, startDate, $scope.reportHistory !== reportName ? true : false, reportName, _selectedReportOption, multiReportOption).then(function (detailReport) {
        $scope.isDataAvailable = true;
        _tmpReportData = detailReport;
        if ($scope.reportHistory !== reportName) {
          $scope.reportHistory = reportName;
          source.localdata = detailReport.dataList;
          column = commonTrackService.getColumnProperties(detailReport.gridSettings.overviewListGrids[0].columnProperties, detailReport.columnTranslation, {
            moduleName: reportName,
            reportModel: 'vehiclePerformanceReport'
          });
          var _additionalProperties = {
            translatedName: $translate.instant('trackReporting.performanceReport.' + reportName.toLoawerCaseAt(0)),
            isDynamicGrid: true,
            dynamicModuleName: reportName
          };
          $scope.gridSettings = commonTrackService.getGridSettings('vehiclePerformanceReport', {
            pagesizeoptions: ['25', '50', '100'],
            pagesize: 25,
            columns: column,
            autosavestate: false,
            height: 670,
            autoloadstate: false
          }, null, _additionalProperties);
          $scope.dataAdapter = new $.jqx.dataAdapter(source);
          $scope.gridSettings.source = $scope.dataAdapter;
          // should be executed only after once successfully creating grid or else 'grid container will be lost', following needed for Jqx 4 changes.
          if (isGridCreated) {
            $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').jqxGrid({
              source: $scope.dataAdapter,
              columns: column
            });
          }
          $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').jqxGrid($scope.gridSettings);

        }
        else {
          source.localdata = detailReport.dataList;
          $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').jqxGrid('updatebounddata', 'data');
        }
        if ($scope.hasMap) {
          // code is not fool proof , 4 seconds wait is for map to show up and select event try to show pushpin if map is already there
          $timeout(function () {
            $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').jqxGrid('selectrow', 0);
          }, 4000);
        }
      }, function (response) {
        $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').jqxGrid('clear');
        $scope.reportHistory = '';
        $scope.mapUrl = '';
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isDataAvailable = false;
        }
      }).finally(function () {

        $timeout(function () {
          $scope.showRepoTab = 1;
          if (!$scope.hasMap) {
            $('#perforManceRepoSpliter').jqxSplitter(reportService.getReportSplitterWithoutMapPannel());
          } else {
            $('#perforManceRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());
          }
          if (!$scope.isEventRegistered) {
            $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').on('filter', function () {
              saveGridSate();
            });
            $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').on('columnresized', function () {
              saveGridSate();
            });

            $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').on('columnreordered', function () {
              saveGridSate();
            });

            $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').on('sort', function () {
              saveGridSate();
            });
            $scope.isEventRegistered = true;
          }
          $scope.dataLoadingFinished = true;
          $scope.initSelectionFinished = true;
        }, 0);
        //  $('#'+$scope.overviewGridPrefix+'vehiclePerformanceReportList').jqxGrid('render');
        $timeout(function () {
          var gridLocalStorageUserSettingKey = reportName + '-' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList';
          reportService.loadReportCustomGridState(_tmpReportData, '#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList', $scope.gridSettings, gridState, gridLocalStorageUserSettingKey);
        }, 1000);
        column = null;
      });
    };

    function saveGridSate() {
      var reportSate = $('#' + $scope.overviewGridPrefix + 'vehiclePerformanceReportList').jqxGrid('getstate');
      reportService.setReportGridState('performanceReport', $scope.radio.name, reportSate);
    }

    function initExport() {
      $scope.exportSetting = reportService.getExportSettings();
      $scope.exportSetting.selectedIndex = 0;
      $scope.exportOption = 'HTML';
    }

    $scope.exportChange = function (event) {
      $scope.exportURL = '';
      if (event.args && event.args.item.value !== 'EMail' && event.args.item.value !== 'HTML') {

        $scope.exportURL = commonTrackService.getExportURL($scope.reportHistory, event.args.item.value, 'Device', $scope.repoVehicle, _selectedReportOption ? _selectedReportOption : '', startDate, endDate, null, $scope.performanceReportPropList);
        reportService.doExport($scope.exportURL, $scope.reportHistory, event.args.item.value);
      } else {
        $scope.exportOption = typeof event === 'object' && event.args && event.args.item.value ? event.args.item.value : event;
        $scope.exportURL = commonTrackService.getExportURL( $scope.reportHistory, event, 'Device', $scope.repoVehicle, _selectedReportOption ? _selectedReportOption : '', startDate, endDate, $scope.reportDetail.emailAddresses, $scope.performanceReportPropList);
        if (!event.args) {
          reportService.doExport($scope.exportURL, $scope.reportHistory, 'EMail');
        }
      }
    };


      $scope.repoVehicleComboChange = function (event) {
      var selectItem = event.args.item;
      if (selectItem) {
        commonTrackService.setDataToLocalStorage('performanceReport', selectItem.value);
      }
      if( event.args&& event.args.item.value ){
        $scope.repoVehicle = event.args.item.value;
      }

      if ($scope.showRepoTab === 1) {
        $scope.getReport({
          _reportName: $scope.radio.name,
          _hasMap: $scope.hasMap,
          _comboModelName: _selectedReportOptionModel
        }, event);
      }
    };
    $scope.$watch('radio.name', function (value) {
      if (value) {
        // after new layout 4 $parent is required to keep breadcrump to keep the link ( better solution have to be found)
        $scope.$parent.breadCrumbLabel = $translate.instant('trackReporting.performance') + ' / ' + $translate.instant('trackReporting.performanceReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
        $scope.$parent.$parent.$parent.$parent.breadCrumbLabel = $translate.instant('trackReporting.performance') + ' / ' + $translate.instant('trackReporting.performanceReport.' + $scope.radio.name._toLowerCaseAtIndex(0));

        commonTrackService.setDataToLocalStorage('performanceRadioName', value);
        commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings,value));
        if ($scope.dataLoadingFinished || value === 'DriverWorkingHours') {
          if (value === 'DriverWorkingHours') {
            $('#repoVehicleComboBox').jqxComboBox({disabled: true});
            $scope.date = {
              startDate: moment().subtract(1, 'months').startOf('month').clone().startOf('day'),
              endDate: moment().subtract(1, 'months').endOf('month').clone().endOf('day')
            };
          } else {
            $('#repoVehicleComboBox').jqxComboBox({disabled: false});
            $scope.date = {
              startDate: moment().clone().startOf('day'),
              endDate: moment()
            };
          }
        }
        startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
        endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');

      }
    });

    // Model dialog for the report 'DriverWorkingHoursDatev'
    $scope.customExport = function (reportItem) {
      var dialogModel = {
        dataRange: $scope.date,
        exportPath: exportPath,
        driverOptionSetting: $scope.driverWorkingHoursSettings,
        selctedOption: $('#' + reportItem._comboID).jqxComboBox('getCheckedItems'),
        deviceId: $scope.repoVehicle
      };
      var modalInstance = $uibModal.open({
        templateUrl: 'components/track/reports/workingHoursDatevDialog.tpl.html',
        sticky: true,
        size: 'lg',
        controller: 'DriverWhDatevExportCtrl',
        resolve: {
          items: function () {
            return dialogModel;
          }
        }
      });

      modalInstance.result.then(function (/* result */) {
        //console.log(result);
      });
    };

    $scope.cancel = function () {
      $scope.showRepoTab = 0;
    };

    var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
      $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings,$scope.radio.name));
      angular.element('#daterange4').trigger('show.daterangepicker');
    });

    function _getDriverIds(isAll, forceUnselect) {
      var driverArr = [];
      if (!isAll) {
        var selectedDrivers = $('#driverWorkingHoursComboBox').jqxComboBox('getCheckedItems');
        for (var i = 0; i < selectedDrivers.length; i++) {
          if (selectedDrivers[i].value !== 'selectAll') {
            driverArr.push(selectedDrivers[i].value);
          }
        }
        return driverArr;
      } else {
        for (var j = 0; j < $scope.driverWorkingHoursSettings.source.length; j++) {
          if ($scope.driverWorkingHoursSettings.source[j].key !== 'selectAll') {
            driverArr.push($scope.driverWorkingHoursSettings.source[j].key);
          } else {
            if (forceUnselect) {
              isAllUncheck = true;
              $('#driverWorkingHoursComboBox').jqxComboBox('uncheckItem', 'selectAll');
              isAllUncheck = false;
            }

          }
        }
        return driverArr;
      }

    }

    function hasAllOptionInSelectedList() {
      var selectedDrivers = $('#driverWorkingHoursComboBox').jqxComboBox('getCheckedItems');
      var isAllFound = false;
      for (var i = 0; i < selectedDrivers.length; i++) {
        if (selectedDrivers[i].value === 'selectAll') {
          isAllFound = true;
          break;
        }
      }
      return isAllFound;
    }

    var isSelectAll = false;
    var isAllUncheck = false;

    function _checkOrUncheckItem(operation) {
      for (var k = 0; k < $scope.driverWorkingHoursSettings.source.length; k++) {
        $('#driverWorkingHoursComboBox').jqxComboBox(operation, $scope.driverWorkingHoursSettings.source[k].key);
      }
    }

    function driverWorkingHoursCheckBoxChangeEvent(event) {
      if (isAllUncheck || isSelectAll) {
        return;
      }
      if (event.args.item.value === 'selectAll' && event.args.checked === true) {
        isSelectAll = true;
        _checkOrUncheckItem('checkItem');
        isSelectAll = false;
        return;
      }
      else if (event.args.item.value === 'selectAll' && event.args.checked === false) {
        isAllUncheck = true;
        _checkOrUncheckItem('uncheckItem');
        isAllUncheck = false;
      }

      if (event.args && event.args.item) {
        isAllUncheck = true;
        $('#driverWorkingHoursComboBox').jqxComboBox('uncheckItem', 'selectAll');
        isAllUncheck = false;
      }
    }

    var workingHoursOptionClearClearEvent = $rootScope.$on('combobox-clear-selection-evt', function (event, data) {
      if (data.id === 'driverWorkingHoursComboBox') {
        // when plant combobox cleared update  related concrete type f8 object .
        isAllUncheck = true;
        _checkOrUncheckItem('uncheckItem');
        isAllUncheck = false;
      }
    });

    $scope.$on('$destroy', function () {
      updateDateRangeInternalDateEvent();
      workingHoursOptionClearClearEvent();
      if ($scope.dataAdapter) {
        delete  $scope.dataAdapter;
      }
      if ($scope.gridSettings && $scope.gridSettings.source) {
        delete $scope.gridSettings.source;
      }
    });
  });



// WEBPACK FOOTER //
// ./.tmp/components/track/reports/performanceReportController.js